export const PDF_NAME = 'ABM-RA21-Digital-rgb.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_HIERARCHY = [
  {
    label: 'Introduction',
    focusLabel: 'Introduction',
    icon: 'icon-home.svg',
    color: 'darkblue',
    pages: [1, 11],
    list: [
      { label: 'Couverture', pages: [1, 3] },
      { label: 'Éditorial', pages: [4, 7] },
      { label: 'Le nouveau président du Conseil d\'administration', pages: [8, 9] },
      { label: 'La préparation des plans ministériels 2022-2026', pages: [10, 11] },
    ],
  },
  {
    label: 'Mise en oeuvre de la nouvelle loi relative à la bioéthique',
    focusLabel: 'Mise en oeuvre de la loi relative à la bioéthique',
    icon: 'icon-page.svg',
    color: 'green',
    pages: [12, 25],
    list: [
      { label: 'Ouverture', pages: [12, 13] },
      { label: 'Assurer le suivi de la loi', pages: [14, 15] },
      { label: 'Un nouveau registre pour les donneurs de gamètes et d\'embryons', pages: [16, 17] },
      { label: 'Cellules souches hématopoïétiques et don intra-familial', pages: [18, 19] },
      { label: 'De nouvelles règles pour favoriser le don croisé', pages: [20, 21] },
      { label: 'Cellules souches : une simplification administrative très attendue', pages: [22, 23] },
      { label: 'Les Journées de l\'Agence', pages: [24, 25] },
    ],
  },
  {
    label: 'Nos équipes',
    focusLabel: 'Nos équipes',
    icon: 'icon-people.svg',
    color: 'pink',
    pages: [26, 35],
    list: [
      { label: 'Ouverture', pages: [26, 27] },
      { label: 'Un nouveau directeur général adjoint chargé des affaires médicales et scientifiques', pages: [28, 29] },
      { label: 'Refonte de Cristal : ergonomie et sécurité renforcées', pages: [30, 31] },
      { label: 'Valoriser la marque employeur de l’Agence', pages: [32, 33] },
      { label: 'L’implication des associations renforce la démocratie sanitaire', pages: [34, 35] },
    ],
  },
  {
    label: 'Nos missions',
    focusLabel: 'Nos missions',
    icon: 'icon-target.svg',
    color: 'blue',
    pages: [36, 59],
    list: [
      { label: 'Ouverture', pages: [36, 37] },
      { label: 'Don, prélèvement et greffes d’organes et de tissus', pages: [38, 43] },
      { label: 'Don et greffe de cellules souches hématopoïétiques', pages: [44, 47] },
      { label: 'Assistance médicale à la procréation et don de gamètes', pages: [48, 51] },
      { label: 'Génétique médicale', pages: [52, 55] },
      { label: 'Promotion de la recherche et actions internationales', pages: [56, 59] },
    ],
  },
  {
    label: 'Annexes',
    focusLabel: 'Annexes',
    icon: 'icon-paperclip.svg',
    color: 'petrolblue',
    pages: [60, 61],
    list: [
      { label: 'Annexes', pages: [60, 61] },
    ],
  },
];

export const MENU_SOCIAL_URL = 'https://google.com';
export const MENU_DISCOVER_NUMBERS_URL = 'https://rams.agence-biomedecine.fr/';
export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 750 / 1013;

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURI('Du don à la vie ! Lisez le rapport annuel 2021 de l\'agence de la biomédecine');
const SHARE_TITLE = encodeURI('Rapport annuel 2021 - ABM');
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const TWITTER_SHARE_PARAMS = `http://twitter.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;

export const WEBSITE_URL = 'https://www.agence-biomedecine.fr/';
export const TWITTER_URL = 'https://twitter.com/ag_biomedecine';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCxbqRMcfj6xvHG3uPqTw2GQ';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-de-la-biomedecine';

const CONFIG = {
  PDF_NAME,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_HIERARCHY,
  MENU_SOCIAL_URL,
  MENU_DISCOVER_NUMBERS_URL,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  TWITTER_SHARE_PARAMS,
  WEBSITE_URL,
  TWITTER_URL,
  YOUTUBE_URL,
  LINKEDIN_URL,
};

export default CONFIG;
